import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'

const levelId = 'level7'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    const lightsOutImage = new GameSceneImage(Config.GAME_SCENE_PATH + 'K38/K38-black.png')
    level.gameScenes.K38.addImage(lightsOutImage)

    const V14_CINEMATIC = new Video(Config.CINEMATIC_PATH + 'V14' + Config.VIDEO_FILE_EXT)
    const V15_CINEMATIC = new Video(Config.CINEMATIC_PATH + 'V15' + Config.VIDEO_FILE_EXT)
    const lightsOnVid = new Video(Config.GAME_SCENE_PATH + 'K38/video/K38-LichtAn' + Config.VIDEO_FILE_EXT)

    ;[V14_CINEMATIC, V15_CINEMATIC, lightsOnVid, lightsOutImage].forEach(LoadingController.addToQueue)

    // Lichtschalter
    level.gameScenes.K38.hideInteractableObject('schrank')
    level.gameScenes.K38.hideWaypoint('K39')
    level.gameScenes.K38.hideWaypoint('K41')
    level.gameScenes.K38.hideWaypoint('K42')

    const lichtschalterAudio = AudioController.add(
        Config.GAME_SCENE_PATH + 'K38/audio/lightswitch' + Config.AUDIO_FILE_EXT
    )

    createInteractableObjectListener(
        'lichtschalter',
        async () => {
            await AudioController.play(lichtschalterAudio)
            CinematicContainer.setVideo(lightsOnVid)
            CinematicContainer.show()
            GameSceneContainer.hide()
            await CinematicContainer.play(false)
            level.gameScenes.K38.removeImage(lightsOutImage)
            level.gameScenes.K38.showInteractableObject('schrank')
            level.gameScenes.K38.showWaypoint('K39')
            level.gameScenes.K38.showWaypoint('K41')
            level.gameScenes.K38.showWaypoint('K42')
            level.gameScenes.K38.hideInteractableObject('lichtschalter')
            CinematicContainer.hide()
            GameSceneContainer.show()
        },
        true
    )

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        createInteractableObjectListener(
            'ausgaben-cottbus',
            async () => {
                CinematicContainer.setVideo(V14_CINEMATIC)
                CinematicContainer.show()
                level.stop()
                AudioController.setMute(true)
                await CinematicContainer.play()
                CinematicContainer.setVideo(V15_CINEMATIC)
                await CinematicContainer.play()
                AudioController.setMute(false)

                resolve()
                level.destroy()
            },
            true
        )
    })
}
